import Welcomegreet from "components/Welcomegreet";
import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import toastr from "toastr";
import {
  Container,
  Button,
  Col,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Spinner,
} from "reactstrap";
import Dropzone from "react-dropzone";
import TimePicker from "react-time-picker";

import {
  addParkingStructureRequest,
  updateParkingStructureRequest,
  getParkingStructureRequest,
  uploadFile,
  getZonesRequest,
} from "store/actions";
import GooglePlacesAutocomplete, {
  getLatLng,
  geocodeByPlaceId,
} from "react-google-places-autocomplete";

import OwnerSelector from "components/OwnerSelector";
import CarParkCodeSelector from "components/CarParkCodeSelector";
import QRCodeStyling from "qr-code-styling";

function AddParking(props) {
  const qrCodeRef = useRef(null);

  const {
    addParkingStructureRequest,
    loading,
    zones,
    getZonesRequest,
    getParkingStructureRequest,
    updateParkingStructureRequest,
    singleParkingStructure,
    addUpdateDeleteLoading,
    user,
    uploadFile,
  } = props;
  const [selectedImagesFile, setselectedImagesFile] = useState([]);
  const [loadingFileUpload, setLoadingFileUpload] = useState(false);
  // console.log("singleParkingStructure", singleParkingStructure);
  const { id } = useParams();
  const [fields, setFields] = useState({
    parkingNumber: "",
    building_name: "",
    // building_abbreviation: "",
    openTime: "09:00 AM",
    closeTime: "09:00 AM",

    location_name: "",
    sensor_status: "",
    lat: "",
    lng: "",
    floors: 0,
    parking_slots: [],
    rate: {
      daily: 0,
      monthly: 0,
      hourly: 0,
    },
    parkingImages: [],
    zoneId: "",
    owner_id: null,
    carparkCode: null,
    type: "Building",
  });

  console.log("fields", fields);
  useEffect(() => {
    if (id) {
      console.log("id", id);
      getParkingStructureRequest(id, () => {
        console.log("callback");
      });
    }
  }, [id]);

  useEffect(() => {
    getZonesRequest({
      orderBy: "createdAt",
      order: -1,
      page: 1,
      limit: 100,
    });
  }, []);

  useEffect(() => {
    if (singleParkingStructure && id) {
      // console.log(singleParkingStructure, "singleParkingStructure")
      try {
        setFields((prev) => ({
          ...prev,
          building_name: singleParkingStructure?.building_name || "",
          sensor_status: singleParkingStructure?.sensor_status || "",
          // building_abbreviation:
          //   singleParkingStructure?.building_abbreviation || "",
          owner_id: singleParkingStructure?.owner_id || "",
          location_name: singleParkingStructure?.location_name || "",
          lat: singleParkingStructure?.location?.coordinates?.[1] || 0,
          lng: singleParkingStructure?.location?.coordinates?.[0] || 0,
          floors: singleParkingStructure?.floors || 0,
          parking_slots: singleParkingStructure?.parking_slots || [],
          rate: singleParkingStructure?.rate,
          parkingImages:
            singleParkingStructure?.parkingImages?.map((item) => item._id) ||
            [],
          openTime: singleParkingStructure?.openTime,
          closeTime: singleParkingStructure?.closeTime,
          parkingNumber: singleParkingStructure?.parkingNumber,
          zoneId: singleParkingStructure?.zoneId?._id,
          type: singleParkingStructure?.type,

          carparkCode: singleParkingStructure?.carparkCode
            ? {
                value: singleParkingStructure?.carparkCode,
                label: singleParkingStructure?.carparkCode,
              }
            : null,
          owner_id: singleParkingStructure.owner_id?._id
            ? {
                value: singleParkingStructure.owner_id?._id,
                label: singleParkingStructure.owner_id?.name,
              }
            : null,
        }));

        setselectedImagesFile(
          singleParkingStructure?.parkingImages?.map((item) => ({
            _id: item._id,
            preview: item.link,
          })) || []
        );
      } catch (err) {
        console.log("parsing error ", err);
      }
    }
  }, [singleParkingStructure, id]);

  const onFieldsChange = (e) => {
    const { name, value } = e.target;

    if (name === "type" && value === "Street") {
      const slots = [];

      for (let i = 1; i <= 1; i++) {
        slots.push({
          floorNo: i,
          parkingSlots: 0,
        });
      }
      setFields({ ...fields, [name]: value, floors: 1, parking_slots: slots });
    } else if (name === "floors") {
      const slots = [];

      for (let i = 1; i <= value; i++) {
        slots.push({
          floorNo: i,
          parkingSlots: 0,
        });
      }
      setFields({ ...fields, [name]: value, parking_slots: slots });
    } else {
      setFields({ ...fields, [name]: value });
    }
  };

  const onChangeOwnerHandler = (data) => {
    setFields((pre) => ({
      ...pre,
      owner_id: data,
    }));
  };

  const onChangeParkCodeHandler = (data) => {
    if (!data) return;
    let makeArr = data.value.split("-");
    if (makeArr.length === 3) {
      setFields((pre) => ({
        ...pre,
        zoneId: zones.find((data) => data.zone_number == makeArr[1])?._id || "",
        parkingNumber: makeArr[2],
        carparkCode: data,
      }));
    } else {
      setFields((pre) => ({
        ...pre,
        carparkCode: data,
      }));
    }
  };

  const onFieldsParkingSlotsChange = (floorNo) => (e) => {
    const { name, value } = e.target;
    const updated = fields?.parking_slots?.map((item) => {
      if (item?.floorNo === floorNo) {
        return {
          ...item,
          parkingSlots: value,
        };
      }
      return item;
    });
    setFields({ ...fields, parking_slots: updated });
  };

  const onSelectGeoLocation = async (data) => {
    try {
      console.log(data, "results");
      const results = await geocodeByPlaceId(data?.value?.place_id);
      const latLng = await getLatLng(results[0]);
      const location_name = results?.[0]?.formatted_address;
      const lat = latLng.lat;
      const lng = latLng.lng;
      console.log("location", location_name);
      setFields((prev) => ({ ...prev, location_name, lat, lng }));
    } catch (error) {
      console.log("Error geocoding address:", error);
    }
  };

  const onSubmitForm = (e) => {
    e.preventDefault();
    let payload = { ...fields };
    // console.log(payload);
    // return

    if (payload.parkingImages.length <= 0) {
      return toastr.error("Parking image required.");
    }

    if (!payload.owner_id) {
      return toastr.error("Owner required");
    }
    if (id) {
      updateParkingStructureRequest(
        {
          ...payload,
          _id: singleParkingStructure?._id,
          owner_id: payload.owner_id?.value,
          carparkCode: payload.carparkCode?.value,
        },
        () => {
          props.history.push("/parking-structure");
        }
      );
    } else {
      addParkingStructureRequest(
        {
          ...payload,
          owner_id: payload.owner_id?.value,
          carparkCode: payload.carparkCode?.value,
        },
        () => {
          props.history.push("/parking-structure");
        }
      );
    }
  };

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  function handleAcceptedFiles(_files) {
    console.log(_files, "_files");
    const files = _files?.filter((file) => file.size < 5242880);

    // if (files.length < _files.length) {
    //   return toastr.error(props.t("max_file_size"))
    // }

    const uploadFileSuccess = (response, status) => {
      try {
        console.log(response, status, "---------------------");
        if (response.status == "success") {
          const { _id: newImageId, link } = response.data;

          //set selected Files after uploaded.
          const fileUploaded = {
            preview: link,
            name: link,
            _id: newImageId,
          };
          console.log(fileUploaded, "fileUploaded");
          setselectedImagesFile((prev) => [...prev, fileUploaded]);
          const copyProfileImages = [...fields.parkingImages];
          copyProfileImages.push(newImageId);
          setFields((prev) => ({ ...prev, parkingImages: copyProfileImages }));
        }
        setLoadingFileUpload(false);
      } catch (e) {
        console.log("e", e);
        setLoadingFileUpload(false);
      }
    };

    files.map((file) => {
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      });
      setLoadingFileUpload(true);
      uploadFile({ image: file }, uploadFileSuccess);
    });
  }

  const onRemoveImage = (index) => {
    const copyImages = [...fields.parkingImages];
    copyImages.splice(index);
    setFields((prev) => ({ ...prev, parkingImages: copyImages }));
    const updatedList = selectedImagesFile.filter((item) =>
      copyImages.includes(item?._id)
    );
    setselectedImagesFile(updatedList);
  };

  const onHandleOpenTime = (time) => {
    setFields((prev) => ({ ...prev, openTime: time }));
  };

  const onHandleCloseTime = (time) => {
    setFields((prev) => ({ ...prev, closeTime: time }));
  };

  useEffect(() => {
    if (qrCodeRef.current) {
      const qrCode = new QRCodeStyling({
        width: 256,
        height: 256,
        data: id,
        margin: 20,
        type: "png",
      });

      qrCode.append(qrCodeRef.current);

      // Store the QR code instance in a ref to access it later
      qrCodeRef.current.qrCodeInstance = qrCode;
    }
  }, [id]);

  const handleDownload = () => {
    if (qrCodeRef.current && qrCodeRef.current.qrCodeInstance) {
      const qrCodeInstance = qrCodeRef.current.qrCodeInstance;

      // Trigger the download using the QR code instance
      qrCodeInstance.download({
        name: `qr_code(${fields.building_name})`,
        extension: "png",
      });
    }
  };
  console.log(fields?.parking_slots, "fields?.parking_slots ");

  return (
    <section className="add_cesormain">
      <div className="page-content">
        <Welcomegreet />
        <Container fluid>
          <a
            href="javascript:void(0)"
            className="backto_censor"
            onClick={() => props.history.push("/parking-structure")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M17.77 3.77L16 2L6 12L16 22L17.77 20.23L9.54 12L17.77 3.77Z"
                fill="#2E3A59"
              />
            </svg>
            {id ? props.t("update") : props.t("add")} {props.t("parking")}
          </a>
          <Form className="add_form" onSubmit={onSubmitForm}>
            <div className="country_fields">
              <Row>
                <Col xs={12} sm={12} md={4} lg={6}>
                  {loadingFileUpload && <Spinner sime="sm" />}
                  <FormGroup>
                    <Label>{props.t("parking_images")}</Label>

                    <Dropzone
                      disabled={loadingFileUpload}
                      onDrop={(acceptedFiles) => {
                        handleAcceptedFiles(acceptedFiles);
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone dropzone-sm">
                          <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                          >
                            <input
                              {...getInputProps()}
                              multiple={false}
                              disabled={loadingFileUpload}
                            />
                            <div className="dz-message needsclick">
                              <div className="mb-3">
                                <i className="display-4 text-muted bx bxs-cloud-upload" />
                              </div>
                              <h4>{props.t("drop_files")}</h4>
                            </div>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    {selectedImagesFile?.length ? (
                      <div className="mt-4 mt-xl-3 parking-add-images-wrap">
                        {selectedImagesFile.map((item, index) => {
                          return (
                            <div
                              key={item?._id}
                              className="parking-add-image-container"
                              onClick={() => onRemoveImage(index)}
                            >
                              <div className="image-delete-icon cursor-pointer">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21"
                                  height="20"
                                  viewBox="0 0 21 20"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_20_1145)">
                                    <path
                                      d="M3.24396 4.09766V18.1464C3.24396 18.5604 3.40842 18.9575 3.70116 19.2502C3.9939 19.543 4.39094 19.7074 4.80493 19.7074H17.2927C17.7067 19.7074 18.1038 19.543 18.3965 19.2502C18.6893 18.9575 18.8537 18.5604 18.8537 18.1464V4.09766H3.24396ZM7.92688 16.1952C7.92688 16.2987 7.88577 16.398 7.81258 16.4712C7.7394 16.5443 7.64014 16.5855 7.53664 16.5855H6.75615C6.65265 16.5855 6.55339 16.5443 6.48021 16.4712C6.40702 16.398 6.36591 16.2987 6.36591 16.1952V7.60985C6.36591 7.50635 6.40702 7.40709 6.48021 7.33391C6.55339 7.26072 6.65265 7.21961 6.75615 7.21961H7.53664C7.64014 7.21961 7.7394 7.26072 7.81258 7.33391C7.88577 7.40709 7.92688 7.50635 7.92688 7.60985V16.1952ZM11.8293 16.1952C11.8293 16.2987 11.7882 16.398 11.715 16.4712C11.6418 16.5443 11.5426 16.5855 11.4391 16.5855H10.6586C10.5551 16.5855 10.4558 16.5443 10.3826 16.4712C10.3095 16.398 10.2683 16.2987 10.2683 16.1952V7.60985C10.2683 7.50635 10.3095 7.40709 10.3826 7.33391C10.4558 7.26072 10.5551 7.21961 10.6586 7.21961H11.4391C11.5426 7.21961 11.6418 7.26072 11.715 7.33391C11.7882 7.40709 11.8293 7.50635 11.8293 7.60985V16.1952ZM15.7318 16.1952C15.7318 16.2987 15.6906 16.398 15.6175 16.4712C15.5443 16.5443 15.445 16.5855 15.3415 16.5855H14.561C14.4575 16.5855 14.3583 16.5443 14.2851 16.4712C14.2119 16.398 14.1708 16.2987 14.1708 16.1952V7.60985C14.1708 7.50635 14.2119 7.40709 14.2851 7.33391C14.3583 7.26072 14.4575 7.21961 14.561 7.21961H15.3415C15.445 7.21961 15.5443 7.26072 15.6175 7.33391C15.6906 7.40709 15.7318 7.50635 15.7318 7.60985V16.1952Z"
                                      fill="#F16573"
                                    />
                                    <path
                                      d="M15.3727 6.82959H14.5298C14.4177 6.82959 14.3101 6.87386 14.2304 6.95279C14.1507 7.03172 14.1055 7.13892 14.1044 7.25105V16.5545C14.1055 16.6666 14.1507 16.7738 14.2304 16.8527C14.3101 16.9317 14.4177 16.9759 14.5298 16.9759H15.3727C15.4849 16.9759 15.5925 16.9317 15.6721 16.8527C15.7518 16.7738 15.7971 16.6666 15.7981 16.5545V7.25105C15.7971 7.13892 15.7518 7.03172 15.6721 6.95279C15.5925 6.87386 15.4849 6.82959 15.3727 6.82959ZM15.7318 16.1954C15.7318 16.2989 15.6906 16.3982 15.6175 16.4714C15.5443 16.5446 15.445 16.5857 15.3415 16.5857H14.561C14.4575 16.5857 14.3583 16.5446 14.2851 16.4714C14.2119 16.3982 14.1708 16.2989 14.1708 16.1954V7.61008C14.1708 7.50658 14.2119 7.40732 14.2851 7.33413C14.3583 7.26095 14.4575 7.21983 14.561 7.21983H15.3415C15.445 7.21983 15.5443 7.26095 15.6175 7.33413C15.6906 7.40732 15.7318 7.50658 15.7318 7.61008V16.1954ZM11.4391 6.82959H10.5961C10.484 6.82959 10.3764 6.87386 10.2967 6.95279C10.2171 7.03172 10.1718 7.13892 10.1708 7.25105V16.5545C10.1718 16.6666 10.2171 16.7738 10.2967 16.8527C10.3764 16.9317 10.484 16.9759 10.5961 16.9759H11.4391C11.5512 16.9759 11.6588 16.9317 11.7385 16.8527C11.8181 16.7738 11.8634 16.6666 11.8644 16.5545V7.25105C11.8634 7.13892 11.8181 7.03172 11.7385 6.95279C11.6588 6.87386 11.5512 6.82959 11.4391 6.82959ZM11.7981 16.1954C11.7981 16.2989 11.757 16.3982 11.6838 16.4714C11.6106 16.5446 11.5114 16.5857 11.4079 16.5857H10.6274C10.5239 16.5857 10.4246 16.5446 10.3514 16.4714C10.2782 16.3982 10.2371 16.2989 10.2371 16.1954V7.61008C10.2371 7.50658 10.2782 7.40732 10.3514 7.33413C10.4246 7.26095 10.5239 7.21983 10.6274 7.21983H11.4079C11.5114 7.21983 11.6106 7.26095 11.6838 7.33413C11.757 7.40732 11.7981 7.50658 11.7981 7.61008V16.1954ZM7.50541 6.82959H6.66249C6.55035 6.82959 6.44274 6.87386 6.36308 6.95279C6.28342 7.03172 6.23815 7.13892 6.23712 7.25105V16.5545C6.23815 16.6666 6.28342 16.7738 6.36308 16.8527C6.44274 16.9317 6.55035 16.9759 6.66249 16.9759H7.50541C7.61756 16.9759 7.72516 16.9317 7.80482 16.8527C7.88448 16.7738 7.92975 16.6666 7.93078 16.5545V7.25105C7.92975 7.13892 7.88448 7.03172 7.80482 6.95279C7.72516 6.87386 7.61756 6.82959 7.50541 6.82959ZM7.86444 16.1954C7.86444 16.2989 7.82332 16.3982 7.75014 16.4714C7.67695 16.5446 7.57769 16.5857 7.47419 16.5857H6.69371C6.59021 16.5857 6.49095 16.5446 6.41776 16.4714C6.34458 16.3982 6.30346 16.2989 6.30346 16.1954V7.61008C6.30346 7.50658 6.34458 7.40732 6.41776 7.33413C6.49095 7.26095 6.59021 7.21983 6.69371 7.21983H7.47419C7.57769 7.21983 7.67695 7.26095 7.75014 7.33413C7.82332 7.40732 7.86444 7.50658 7.86444 7.61008V16.1954Z"
                                      fill="#DB5669"
                                    />
                                    <path
                                      d="M11.0488 4.09766L16.2082 4.67092C16.3991 4.69215 16.5755 4.78303 16.7036 4.92616C16.8317 5.0693 16.9025 5.25465 16.9025 5.44673V19.7074H17.2927C17.7067 19.7074 18.1038 19.543 18.3965 19.2502C18.6892 18.9575 18.8537 18.5604 18.8537 18.1464V4.09766H11.0488Z"
                                      fill="#DB5669"
                                    />
                                    <path
                                      d="M10.6586 4.09766L4.80493 4.74819V19.7074C4.39094 19.7074 3.9939 19.543 3.70116 19.2502C3.40842 18.9575 3.24396 18.5604 3.24396 18.1464V4.09766H10.6586Z"
                                      fill="#F97A8D"
                                    />
                                    <path
                                      d="M8.70734 0.195312H13.3903C13.8043 0.195313 14.2013 0.359772 14.494 0.652512C14.7868 0.945252 14.9512 1.34229 14.9512 1.75629V2.53678H7.14636V1.75629C7.14636 1.34229 7.31082 0.945252 7.60356 0.652512C7.8963 0.359772 8.29334 0.195313 8.70734 0.195312Z"
                                      fill="#374F68"
                                    />
                                    <path
                                      d="M1.29271 2.53662H20.4147C20.5182 2.53662 20.6174 2.57774 20.6906 2.65092C20.7638 2.72411 20.8049 2.82337 20.8049 2.92687V3.70735C20.8049 3.81085 20.7638 3.91011 20.6906 3.9833C20.6174 4.05648 20.5182 4.0976 20.4147 4.0976H1.29271C1.18921 4.0976 1.08995 4.05648 1.01677 3.9833C0.943581 3.91011 0.902466 3.81085 0.902466 3.70735V2.92687C0.902466 2.82337 0.943581 2.72411 1.01677 2.65092C1.08995 2.57774 1.18921 2.53662 1.29271 2.53662Z"
                                      fill="#30455C"
                                    />
                                    <path
                                      d="M20.8049 2.92687H1.68295C1.57945 2.92687 1.48019 2.96798 1.40701 3.04116C1.33382 3.11435 1.29271 3.21361 1.29271 3.31711V4.0976C1.18921 4.0976 1.08995 4.05648 1.01677 3.9833C0.943581 3.91011 0.902466 3.81085 0.902466 3.70735V2.92687C0.902466 2.82337 0.943581 2.72411 1.01677 2.65092C1.08995 2.57774 1.18921 2.53662 1.29271 2.53662H20.4147C20.5182 2.53662 20.6174 2.57774 20.6906 2.65092C20.7638 2.72411 20.8049 2.82337 20.8049 2.92687Z"
                                      fill="#374F68"
                                    />
                                    <path
                                      d="M9.48783 0.585556H14.1708C14.2652 0.584776 14.3592 0.593752 14.4517 0.612874C14.163 0.345167 13.784 0.196077 13.3903 0.195312L8.70734 0.195313C8.29334 0.195313 7.8963 0.359772 7.60356 0.652512C7.31082 0.945252 7.14636 1.34229 7.14636 1.75629V2.53678H11.8293L9.00705 2.25463C8.84882 2.23927 8.69906 2.17597 8.5778 2.07318C8.45653 1.9704 8.36955 1.83303 8.32847 1.67947C8.28739 1.5259 8.29419 1.36345 8.34795 1.21385C8.40171 1.06425 8.49986 0.934635 8.62929 0.842337C8.88405 0.674316 9.18264 0.585011 9.48783 0.585556Z"
                                      fill="#46617A"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_20_1145">
                                      <rect
                                        width="19.9024"
                                        height="19.9024"
                                        fill="white"
                                        transform="translate(0.902466)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                              <img
                                width="100px"
                                height="130px"
                                src={item?.preview}
                                alt="parking-image"
                              />
                            </div>
                          );
                        })}
                      </div>
                    ) : null}
                  </FormGroup>
                </Col>
                {id && (
                  <Col xs={12} sm={12} md={4} lg={6}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      ref={qrCodeRef}
                    ></div>
                    <div
                      style={{
                        cursor: "pointer",
                        textAlign: "center",
                        textAnchor: "-moz-initial",
                      }}
                      onClick={handleDownload}
                    >
                      Download
                    </div>
                  </Col>
                )}
              </Row>
              <Row>
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <Label for="exampleEmail">
                      {props.t("building")} / {props.t("parking")}{" "}
                      {props.t("name")}
                    </Label>
                    <Input
                      type="text"
                      name="building_name"
                      value={fields.building_name}
                      id="exampleEmail"
                      // placeholder="BG"
                      onChange={onFieldsChange}
                      required
                    />
                  </FormGroup>
                </Col>

                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <Label for="exampleEmail">
                      {props.t("building")} / {props.t("parking")}{" "}
                      {props.t("short_name")}
                    </Label>
                    <CarParkCodeSelector
                      placeholder={props.t("select")}
                      isMulti={false}
                      defaultSelected={fields.carparkCode}
                      onChangeHandler={onChangeParkCodeHandler}
                    />
                  </FormGroup>
                </Col>
                {/* <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <Label for="exampleEmail">
                      {props.t("building")} / {props.t("parking")}{" "}
                      {props.t("short_name")}
                    </Label>
                    <Input
                      type="text"
                      name="building_abbreviation"
                      value={fields.building_abbreviation}
                      id="exampleEmail"
                      placeholder="Example: B1"
                      onChange={onFieldsChange}
                      required
                    />
                  </FormGroup>
                </Col> */}
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <Label for="exampleEmail">
                      {props.t("building")} / {props.t("parking")}{" "}
                      {props.t("number")}
                    </Label>
                    <Input
                      type="number"
                      name="parkingNumber"
                      min={0}
                      value={fields.parkingNumber}
                      id="exampleEmail"
                      placeholder={`${props.t("example")}: 01`}
                      onChange={onFieldsChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <Label for="exampleEmail">{props.t("sensor_status")}</Label>
                    <Input
                      type="select"
                      name="sensor_status"
                      value={fields.sensor_status}
                      id="exampleEmail"
                      // placeholder="BG"
                      onChange={onFieldsChange}
                      required
                    >
                      <option value="">{props.t("select")}</option>
                      {["Yes", "No"].map((item) => {
                        return <option value={item}>{item}</option>;
                      })}
                    </Input>
                  </FormGroup>
                </Col>

                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <Label for="exampleEmail">{props.t("zone")}</Label>
                    <Input
                      type="select"
                      name="zoneId"
                      value={fields.zoneId}
                      id="exampleEmail"
                      // placeholder="BG"
                      onChange={onFieldsChange}
                      required
                    >
                      <option value="">{props.t("select")}</option>
                      {zones?.map((item) => {
                        return (
                          <option value={item?._id}>{item?.zone_name}</option>
                        );
                      })}
                    </Input>
                  </FormGroup>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <Label for="exampleEmail">{props.t("opening_time")}</Label>
                    <div>
                      <TimePicker
                        onChange={onHandleOpenTime}
                        name="openTime"
                        value={fields.openTime}
                        format="h:mm a"
                        disableClock
                      />
                    </div>
                  </FormGroup>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <Label for="exampleEmail">{props.t("closing_time")}</Label>
                    <div>
                      <TimePicker
                        onChange={onHandleCloseTime}
                        value={fields.closeTime}
                        name="closeTime"
                        format="h:mm a"
                        disableClock
                      />
                    </div>
                  </FormGroup>
                </Col>
                <Col lg={6} md={12} sm={12}>
                  <FormGroup>
                    <Label for="exampleEmail">{props.t("owner")}</Label>
                    <OwnerSelector
                      placeholder={props.t("select")}
                      isMulti={false}
                      defaultSelected={fields.owner_id}
                      onChangeHandler={onChangeOwnerHandler}
                    />
                  </FormGroup>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <Label for="exampleEmail">{props.t("location")}</Label>
                    {/* <Input
                    type="text"
                    name="location_name"
                    value={fields.location_name}
                    id="exampleEmail"
                    placeholder=""
                    onChange={onFieldsChange}
                  /> */}
                    <GooglePlacesAutocomplete
                      apiKey={process.env.REACT_APP_GOOGLE_APIKEY || ""}
                      selectProps={{
                        placeholder: fields.location_name || "",
                        onChange: onSelectGeoLocation,
                        onSelect: true,
                      }}
                      onLoadFailed={(error) => {
                        console.log(error);
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    <Label for="exampleEmail">{props.t("type")}</Label>
                    <Input
                      type="select"
                      name="type"
                      value={fields.type}
                      id="exampleEmail"
                      // placeholder="BG"
                      onChange={onFieldsChange}
                      required
                    >
                      <option value="">{props.t("select")}</option>
                      {["Building", "Street"].map((item) => {
                        return <option value={item}>{item}</option>;
                      })}
                    </Input>
                  </FormGroup>
                </Col>
                {fields.type !== "Street" && (
                  <Col lg={6} md={6} sm={12}>
                    <FormGroup>
                      <Label for="exampleEmail">
                        {props.t("floor_number")}
                      </Label>
                      <Input
                        type="number"
                        name="floors"
                        min={0}
                        value={fields.floors}
                        id="exampleEmail"
                        placeholder=""
                        onChange={onFieldsChange}
                        required
                      />
                    </FormGroup>
                  </Col>
                )}
              </Row>
              <Row>
                <Col lg={6} md={6} sm={12}>
                  <FormGroup>
                    {/* <Label for="exampleEmail">{props.t("parking_slots")}</Label> */}
                    {/* <Input
                    type="number"
                    name="parking_slots"
                    min={0}
                    value={fields.parking_slots}
                    id="exampleEmail"
                    placeholder=""
                    onChange={onFieldsChange}
                  /> */}
                  </FormGroup>
                </Col>
              </Row>
              {(fields?.parking_slots || [])?.map((item, index) => (
                <Row key={index}>
                  <Col lg={6} md={6} sm={12}>
                    <FormGroup>
                      <Label for="exampleEmail">{props.t("floor_level")}</Label>
                      <Input
                        type="number"
                        // disabled
                        name="floorNo"
                        // min={0}
                        value={item.floorNo == 0 ? "0" : item.floorNo || ""}
                        id="exampleEmail"
                        placeholder=""
                        required
                        // onChange={(e)=>onFieldsParkingSlotsChange(index)(e)}
                        onChange={
                          (e) => {
                            const updated = fields?.parking_slots?.map(
                              (item, i) => {
                                if (index === i) {
                                  return {
                                    ...item,
                                    floorNo: parseInt(e.target.value),
                                  };
                                }
                                return item;
                              }
                            );
                            setFields({ ...fields, parking_slots: updated });
                          }
                          // onFieldsParkingSlotsChange(item?.floorNo)(e)
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <FormGroup>
                      <Label for="exampleEmail">
                        {props.t("parking_slots")}
                      </Label>
                      <Input
                        type="number"
                        name="parkingSlots"
                        min={0}
                        value={item?.parkingSlots}
                        id="exampleEmail"
                        placeholder=""
                        onChange={(e) =>
                          onFieldsParkingSlotsChange(item?.floorNo)(e)
                        }
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
              ))}
              {/* <Row>
                 <Col lg={12}>
                    <h4>{props.t("rate")}</h4>
                 </Col>
                 <Col lg={4} md={4} sm={12}>
                    <FormGroup>
                      <Label for="exampleEmail">{props.t("hourly")}</Label>
                      <Input
                        type="number"
                        name="hourly"
                        min={1}
                        required
                        value={fields?.rate?.hourly || 0}
                        id="exampleEmail"
                        placeholder=""
                        onChange={onRatesChange}
                      />
                    </FormGroup>
                 </Col>
                 <Col lg={4} md={4} sm={12}>
                    <FormGroup>
                      <Label for="exampleEmail">{props.t("daily")}</Label>
                      <Input
                        type="number"
                        name="daily"
                        min={1}
                        required
                        value={fields?.rate?.daily || 0}
                        id="exampleEmail"
                        placeholder=""
                        onChange={onRatesChange}
                      />
                    </FormGroup>
                 </Col>
                 <Col lg={4} md={4} sm={12}>
                    <FormGroup>
                      <Label for="exampleEmail">{props.t("monthly")}</Label>
                      <Input
                        type="number"
                        name="monthly"
                        min={1}
                        required
                        value={fields?.rate?.monthly || 0}
                        id="exampleEmail"
                        placeholder=""
                        onChange={onRatesChange}
                      />
                    </FormGroup>
                 </Col>
            </Row>
          */}
            </div>

            <Button type="submit" className="btn_addform mt-5">
              {addUpdateDeleteLoading ? (
                <Spinner size="sm" type="light" />
              ) : null}
              {id ? props.t("update") : props.t("add")}
            </Button>
          </Form>
        </Container>
      </div>
    </section>
  );
}

const mapStateToProps = ({ Parkings, Login, Dashboard }) => {
  return {
    user: Login.user,
    loading: Parkings.loading,
    singleParkingStructure: Parkings.singleParkingStructure,
    addUpdateDeleteLoading: Parkings.addUpdateDeleteLoading,
    zones: Dashboard.zones,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addParkingStructureRequest: (data, callback) => {
      dispatch(addParkingStructureRequest(data, callback));
    },
    getParkingStructureRequest: (data, callback) => {
      dispatch(getParkingStructureRequest(data, callback));
    },
    updateParkingStructureRequest: (data, callback) => {
      dispatch(updateParkingStructureRequest(data, callback));
    },
    uploadFile: (data, callback) => dispatch(uploadFile(data, callback)),
    getZonesRequest: (data, callback) => {
      dispatch(getZonesRequest(data, callback));
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddParking))
);
